<template>
    <div class="max-img" @click="close">
        <header>
            <div class="close" @click="close"></div>
            <!-- <div class="num">{{page}}/{{imgList.length}}</div> -->
        </header>
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,i) in imgList" :key="i">
                    <div class="swiper-item">
                        <img :src="item" alt="" class="gray">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './../../static/js/swiper-3.4.1.min.js';
export default {
    name: 'ViewImg',
    data(){
        return {
            page: 1,
            isShowDel: false
        }
    },
    props:['imgList'],
    created(){

    },
    mounted(){
         this.$nextTick(()=>{
           //实例swiper
           var swiper = new Swiper('.swiper-container', {
               freeMode: false,
               paginationClickable: true,
               observer: true,
               initialSlide: this.index,
               onSlideChangeEnd: (swiper)=>{ //swiper切换事件
                    // console.log(swiper.activeIndex)
                    this.page = Number(swiper.activeIndex)+1;
               }
            });
            window.scrollTo(0, 0);
        })
    },
    methods:{
        close(){
            this.$emit('close');
        },
        cancle(){
            this.isShowDel = false;
        }
    },
    watch:{
        imgList:{
            deep: true,
            // immediate: true,
            handler(newV,oldV){
                if(newV.length == 0){
                    this.close()
                }
                if(newV.length < this.page){
                    this.page = newV.length
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
header{
    width: 100%;
    height: .88rem;
    background:rgba(0,0,0,0.2);
    position: relative;
    .close{
        width: .44rem;
        height: .44rem;
        background: url('./../../static/img/close-logo.png') no-repeat;
        background-size: .44rem .44rem;
        float: left;
        margin-left: .3rem;
        margin-top: .28rem;
    }
    .num{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        color: #fff;
        font-size: .32rem;
    }
    .del{
         width: .44rem;
        height: .44rem;
        background: url('./../../static/img/del-img.png') no-repeat;
        background-size: .44rem .44rem;
        float: right;
        margin-right: .3rem;
        margin-top: .28rem;
    }
}
.header-bg{
    background-color: #fff
}
.del-tips{
    width: 100%;
    height: 0;
    overflow: hidden;
    background-color: rgba(0,0,0,.2);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    .opt{
        position: absolute;
        bottom: -1.2rem;
        transition: transform .4s ease;
        left: .15rem;
    }
    .del-btn{
        width: 3.45rem;
        height: .54rem;
        background-color: #fff;
        text-align: center;
        line-height: .54rem;
        font-size: .17rem;
        color: #7096FF;
        border-radius: .12rem;
        margin-bottom: .1rem;
    }
    .cancle-btn{
        width: 3.45rem;
        height: .54rem;
        background-color: #fff;
        text-align: center;
        line-height: .54rem;
        font-size: .17rem;
        color: #B8B8B8;
        border-radius: .12rem;

    }
}
.del-tip-height{
    height: 100%
}
.showTranslate{
    transform: translateY(-1.3rem);
}
.max-img{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #000;
}
 .swiper-container {
    width: 100%;
    margin: 0;
    padding: 0;
    height: 100%;
  }
  .swiper-container::-webkit-scrollbar{
      -webkit-appearance: none;
      display: none
  }
  .swiper-slide img {
    max-width: 100%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%,-50%);
  }
  .swiper-slide {
      height: 100%;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    .title{
       width: 100%;
        height: .6rem;
        background-color: rgba(0,0,0,.6);
        text-indent: 1em;
        line-height: .6rem;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: left;
        color: #fff;
        p{
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
    }
  }
  .swiper-item{
      width: 100%;
      height: 100%;
      line-height: .44rem;
      text-align: left;
      font-size: .28rem;
      overflow: auto;
      color: #333;
  }
.gray {} 
.cs{

}
</style>



// WEBPACK FOOTER //
// src/components/viewImg.vue